import React from "react";
import TutorLayout from "./TutorLayout";

function TutorHelpPage() {
  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>🆘 Tutor Help Guide</h1>
        <p style={styles.subtitle}>All the tips and instructions to keep your tutor platform running smoothly!</p>

        {/* SECTION 1 */}
        <div style={styles.section}>
          <h2>📖 How to Add a New Lesson</h2>
          <ol>
            <li>Go to <strong>Assignment Manager → Set an Assignment</strong>.</li>
            <li>Fill out the assignment form (title, subject, topic, subtopic, etc.).</li>
            <li>Make sure <strong>Assignment Type = classwork</strong>.</li>
            <li>Submit — this adds the classwork for the student.</li>
            <li>Now go to <strong>Manage Classwork</strong>.</li>
            <li>Select the student, then add slides or video URLs to that lesson.</li>
            <li>Click 💾 Save — it appears for the student instantly!</li>
          </ol>
        </div>

        {/* SECTION 2 */}
        <div style={styles.section}>
          <h2>🧪 How to Set Assignments</h2>
          <ul>
            <li>Go to <strong>Assignment Manager → Set an Assignment</strong>.</li>
            <li>Choose an <code>assignmentType</code>:
              <ul>
                <li><code>classwork</code> → shows on the Classwork page</li>
                <li><code>homework</code> → use if you plan to mark it later</li>
              </ul>
            </li>
            <li>Use topics and subtopics to organize lessons by subject.</li>
          </ul>
        </div>

        {/* SECTION 3 */}
        <div style={styles.section}>
          <h2>📑 How to Upload Resources</h2>
          <p>If you still want to use the Upload Resource form:</p>
          <ol>
            <li>Go to <strong>/upload-resource</strong>.</li>
            <li>Select the student + subject + topic + subtopic.</li>
            <li>Add the title, Google Slides link, and/or Video link.</li>
            <li>Submit — the resource will be linked with matching assignments.</li>
          </ol>
        </div>

        {/* SECTION 4 */}
        <div style={styles.section}>
          <h2>📚 How the Classwork Page Works</h2>
          <ul>
            <li>Classwork lessons = assignment + resource merged together.</li>
            <li>The system matches based on:
              <code>subject + topic + subtopic + assignedToUID</code>
            </li>
            <li>If only the assignment exists → it still shows.</li>
            <li>If only the resource exists → it still shows.</li>
            <li>If both exist → they are merged into one lesson card.</li>
          </ul>
        </div>

        {/* SECTION 5 */}
        <div style={styles.section}>
          <h2>🧑‍🏫 User Roles Explained</h2>
          <ul>
            <li><strong>student</strong> – sees assignments, classwork, lessons, etc.</li>
            <li><strong>tutor</strong> – can create, assign, upload, and manage everything.</li>
          </ul>
        </div>

        {/* You can keep adding new help sections below */}
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    maxWidth: "900px",
    margin: "0 auto",
    fontFamily: "'Poppins', sans-serif",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "2rem",
    color: "#636e72",
  },
  section: {
    marginBottom: "2.5rem",
    backgroundColor: "#fffdf4",
    padding: "1.2rem 1.5rem",
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
};

export default TutorHelpPage;
